import React from "react";

export interface ICopyToClipboardProps {
    value: string;
    className?: string;
}

const CopyToClipboard: React.FC<ICopyToClipboardProps> = ({value, className=""}) => {

    const [copied, setCopied] = React.useState(false);

    const handleCopyToClipboard = (value: string) => {
        navigator.clipboard.writeText(value).then(() => setCopied(true));
        setTimeout(() => setCopied(false), 2000);
    }

    return (
        <div>
            <div className={`copyToClipboard ${className}`}>
                <div className="copyText">
                    {value}
                </div>
                <button className="copyButton" onClick={() => handleCopyToClipboard(value)}>
                    <i className="icon ms-Icon ms-Icon--Copy"></i>
                </button>
            </div>
            {copied && <span style={{marginLeft: '8px', color: 'green'}}>Copied!</span>}
        </div>
    )

}

export default CopyToClipboard;